export default __webpack_public_path__ + "7dc94c2b68ac72100927f5000f9e6c7e.svg";